export enum APP_SNACKBAR_VARIANT {
    INFO = "info",
    SUCCESS = "success",
    ERROR = "error",
    WARNING = "warning"
}


export interface AppSnackbarProps {
    open: boolean;
    message: string;
    variant?: APP_SNACKBAR_VARIANT;
    duration?: number;
    className?: string
    onClose?: () => void;
}